import React from 'react';
import {
  Box, Divider, Paper, Toolbar, Typography,
} from "@mui/material";
import { ApiResourceTable, ApiResourceTableProps } from "../../../comps/api-resource-table/ApiResourceTable";
import { UpdateGroupFarmDto } from "../../../models/domain/UpdateGroupFarmDto";

export const UpdateGroupAssignedFarmsForm = (props: ApiResourceTableProps<UpdateGroupFarmDto>) => {
  return (
    <Paper elevation={2} sx={{mt: 2}}>
      <Box sx={{mt: 1}}>
        <Box sx={{pt: 1, pb: 1}}>
          <Toolbar sx={{background: "inherit"}} variant="dense">
            <Typography component="h1" variant="h6" fontWeight="lighter" minWidth="230px">
              Assigned Farms
            </Typography>
          </Toolbar>
        </Box>

        <Divider/>

        <ApiResourceTable {...props} />
      </Box>
    </Paper>
  );
}
